export default __webpack_public_path__ + "static/media/Wheel21.07.2025.025c630e.riv";